import React from 'react';
import { TooltipContainer } from './styles';
const PriceTooltip = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(TooltipContainer, {
    flexDirection: "column",
    alignItems: "center"
  }, children);
};
export default PriceTooltip;